export type DisplayNormalEvent = "通常日課";

export const displayNormalEvent: DisplayNormalEvent = "通常日課";
